import { withInstall } from '../_util'

import Icon from './Icon.vue'
export default withInstall<typeof Icon, {}>(Icon, {})
